<form [formGroup]="form">
  <!-- #178 slice B: the reading language, stored per profile so it follows the user
       across devices and clients rather than living in this browser. -->
  <div class="mt-4">
    <h3 i18n>Sprache</h3>
    <hr />
    <div class="row mb-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-6 col-form-label" for="language" i18n="@@settings.language">Sprache der Oberfläche</label>
          <div class="col-sm-6">
            <select
              id="language"
              class="form-select"
              formControlName="language"
              data-testid="settings-language-select"
              >
              @for (language of languages; track language.code) {
                <option [value]="language.code">{{ language.name }}</option>
              }
            </select>
          </div>
        </div>
        <p class="text-muted small mt-2" i18n>
          Gilt auf allen Geräten, auf denen Sie angemeldet sind. Beim Speichern wird die
          Seite in der neuen Sprache neu geladen.
        </p>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <h3 i18n>Listen</h3>
    <hr />
    <div class="row mb-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-6 col-form-label" for="listPageSize" i18n="@@settings.listPageSize">Einträge pro Seite</label>
          <div class="col-sm-6">
            <kendo-dropdownlist
              id="listPageSize"
              data-testid="settings-list-page-size"
              class="w-100"
              [data]="pageSizes"
              formControlName="listPageSize"
              ></kendo-dropdownlist>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4">
    @if (profile?.isActive) {
      <button
        class="btn btn-primary m-2"
        type="button"
        data-testid="settings-user-save"
        [asyncClick]="save.bind(this)"
        [disabled]="saveBtn.disabled || form.pristine"
        #saveBtn="asyncClick"
        i18n
        >
        @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Einstellungen speichern
      </button>
    }
  </div>
</form>
